module.exports = __webpack_public_path__ + "img/newspic1.b0ee03f4.jpg";